import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrl;
const API_VERSION = environment.MSImagingProjectVersion;
const SERVICE = 'msimagingproject-dot-';
const requestURL = 'https://' + API_VERSION + SERVICE + API_URL;

@Injectable({
  providedIn: 'root'
})
export class ScannerService {

  constructor(private http: HttpClient) { }

  create(scanner: any) {
    return this.http.post(requestURL + `/scanner`, scanner);
  }

  update(scanner: any) {
    return this.http.put(requestURL + `/scanner`, scanner);
  }

  delete(id: number) {
    return this.http.delete(requestURL + `/scanner/` + id);
  }

  getById(id: number) {
    return this.http.get(requestURL + `/scanner/` + id);
  }

  getAll() {
    return this.http.get(requestURL + `/scanner/retrieve-all`);
  }
}